
import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
    },
    
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      transform: 'translate(15.50px, 5px) scale(0.73)', 
      
      color: 'rgba(50,50,100,0.55)',
  },

  '& .MuiOutlinedInput-root': { 
    position: 'relative',
    borderRadius: '0px', },
  


  },
  paper: {
    padding: theme.spacing(2),
  },
  form: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  fileInput: {
    width: '97%',
    margin: '10px 0',
  },
  buttonSubmit: {
    marginBottom: 10,
  },


  



}));
